export function truncateText(text: string, maxLength: number): string {
	if (text.length <= maxLength) {
		return text;
	}

	const truncated = text.slice(0, maxLength - 1);
	return `${truncated}…`;
}
